import { Button } from 'components/Elements';
import { Form, InputField } from 'components/Form';
import { useAuth } from 'lib/auth';
import PropTypes from 'prop-types';
import * as z from 'zod';

const schema = z.object({
  phoneNumber: z.string().min(1, 'Required'),
  pin: z.string().min(1, 'Required'),
});

export const LoginForm = ({ onSuccess }) => {
  const { login, isLoggingIn } = useAuth();

  return (
    <div>
      <Form
        onSubmit={async (values) => {
          await login(values);
          onSuccess();
        }}
        schema={schema}
      >
        {({ register, formState }) => (
          <>
            <InputField
              type="text"
              label="Phone Number"
              error={formState.errors['phoneNumber']}
              registration={register('phoneNumber')}
            />
            <InputField
              type="password"
              label="PIN"
              error={formState.errors['pin']}
              registration={register('pin')}
            />
            <div>
              <Button variant="secondary" isLoading={isLoggingIn} type="submit" className="w-full">
                Sign in
              </Button>
            </div>
          </>
        )}
      </Form>
    </div>
  );
};

LoginForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};
